// extracted by mini-css-extract-plugin
export default {"box":"SaveValue_box__EpK31","union":"SaveValue_union__VR+zv","label":"SaveValue_label__RXW3K"};